import React from 'react';
import { Accordion, Form , Table } from 'react-bootstrap';
import ModifTournoi from './modifTournois';
import GestionTournoi from './gestionTournoi';

function TournoisAffichageGestion(props) {
  return (
    <>
      <Accordion defaultActiveKey="0">
        {props.tournoisEquipe && props.tournoisEquipe.map((item, index) => {
          const equipes = item.equipes_participantes ? item.equipes_participantes.split(', ') : [];
          const commentaires = item.commentaireEquipes ? item.commentaireEquipes.split(', ') : [];

          return (
            <Accordion.Item key={index} eventKey={index}>
              <Accordion.Header>
                <div>
                  <strong>{item.nomTournois}</strong>
                  <hr/>
                  Lieu : <strong>{item.localisation}</strong>
                  <br/>
                  Date du tournoi : <strong>{item.date}</strong>
                  <br/>
                  Nombres de participants : <strong>{item.nombre_participants} / {item.nbr_equipe} </strong>
                </div>
              </Accordion.Header>
              {item.status === 'en attente' ? (
                <Accordion.Body>
                  <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                    Il y a actuellement <strong>{item.nombre_participants}</strong> équipes qui veulent participer à votre tournoi.
                    <br/>
                    <strong>Liste des équipes voulant participer.</strong>
                  </div>
                  <br/>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Nom de l'équipe</th>
                        <th>Commentaire</th>
                      </tr>
                    </thead>
                    <tbody>
                      {equipes.map((equipe, equipeIndex) => (
                        <tr key={equipeIndex}>
                          <td>{equipe}</td>
                          <td><Form.Control as="textarea" disabled rows={2} value={commentaires[equipeIndex] !== null ? (commentaires[equipeIndex]) : ('')} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <hr/>
                  <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                    <strong>Modifier les informations du tournoi </strong>
                  </div>
                  <ModifTournoi item={item} userData={props.userData} />
                  <hr/>
                  <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                    <strong>Clôturer la recherche de participant pour le tournoi.</strong>
                  </div>
                  &nbsp;
                  <br/>
                  <GestionTournoi item={item} userData={props.userData} />
                </Accordion.Body>
              ) : (
                <Accordion.Body>
                  <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                    Vous avez <strong>{item.status}</strong> le tournoi.
                  </div>
                  {item.status === 'confirmer' ? (
                    <>
                      <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                        <strong>Liste des équipes qui participe.</strong>
                      </div>
                      <br/>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Nom de l'équipe</th>
                            <th>Commentaire</th>
                          </tr>
                        </thead>
                        <tbody>
                          {equipes.map((equipe, equipeIndex) => (
                            <tr key={equipeIndex}>
                              <td>{equipe}</td>
                              <td><Form.Control as="textarea" disabled rows={2} value={commentaires[equipeIndex] !== null ? (commentaires[equipeIndex]) : ('')} /></td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                        <strong>Changer le status du tournoi</strong>
                      </div>
                      &nbsp;
                      <br/>
                      <GestionTournoi item={item} userData={props.userData} />
                    </>
                  ) : (
                    <>
                      <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                        <strong>Changer le status du tournoi</strong>
                      </div>
                      &nbsp;
                      <br/>
                      <GestionTournoi item={item} userData={props.userData} />
                    </>
                  )}
                </Accordion.Body>
              )}
            </Accordion.Item>
          );
        })}
      </Accordion>
      <br/>
    </>
  );
}

export default TournoisAffichageGestion;
